var formations = {
  main: {
    _fopt1:{
      name: "Permis B (boite manuelle)",
      icon: "manu",
      description: "20h de conduite sur route\n(avec ou sans code)",
      id: 1
    },
    _fopt2:{
      name: "Permis B (boite automatique)",
      icon: "auto",
      description: "13h de conduite sur route\n(Possibilité d'une formation 7h pour boite manuelle)",
      id: 2
    },
    _fopt3:{
      name: "Permis A2 (moto)",
      icon: "moto",
      description: "8h sur plateau + 12h sur route\n(avec ou sans code)",
      id: 3
    }
  },
  other: {
    _fopt4:{
      name: "Code seul",
      icon: "code",
      description: "2h de cours particuliers inclus",
      id: 4
    },
    _fopt5:{
      name: "Recuperation de points",
      icon: "recup-point",
      description: "Stage de 2 jours",
      id: 5
    },
    _fopt6:{
      name: "Annulation de permis",
      icon: "annulation",
      description: "Visite médicale & test psychotechnique",
      id: 6
    },
    _fopt7:{
      name: "Permis côtier",
      icon: "bateau",
      description: "16h de navigation à Paris\n7h en province",
      id: 7
    },
    _fopt8:{
      name: "Licence PPL Helicopter",
      icon: "ppl-helico",
      description: "45h de vol",
      id: 8
    },
    _fopt9:{
      name: "Licence PPL Avion",
      icon: "ppl-avion",
      description: "45h de vol",
      id: 9
    }
  }
} 

module.exports = formations;


// WEBPACK FOOTER //
// ./go/views/components/signup/_foptions.jsx